<template>
  <simple-modal :visible="visible" @close="emit('dismiss')">
    <div class="text-center" @click.stop>
      <p class="mb-2 text-4xl">⭐</p>
      <h2 class="mb-2 text-xl font-bold dark:text-slate-200">
        {{ t("components.app_review.title") }}
      </h2>
      <p class="mb-6 text-gray-600 dark:text-slate-300">
        {{ t("components.app_review.message") }}
      </p>
      <div class="flex items-center justify-between gap-4">
        <p
          class="cursor-pointer text-gray-500 dark:text-slate-400"
          @click="emit('dismiss')"
        >
          {{ t("components.app_review.dismiss") }}
        </p>
        <default-button color="blue" @click="emit('accept')">
          {{ t("components.app_review.accept") }}
        </default-button>
      </div>
    </div>
  </simple-modal>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import SimpleModal from "@/components/Modals/SimpleModal.vue";
import DefaultButton from "@/components/Buttons/DefaultButton.vue";

const { t } = useI18n({ useScope: "global" });

type Props = {
  visible: boolean;
};
defineProps<Props>();

const emit = defineEmits<{
  (e: "accept"): void;
  (e: "dismiss"): void;
}>();
</script>
